module.exports = __webpack_public_path__ + "static/media/ParkinglottramDollywoodPigeonForgeTN2006Gouacheonvintagenotecard.1b6ac332.webp";